app.filter('money', ['$sce', function ($sce) {

    return function (amount, symbol) {
        let culture = gym[0].Culture || 'en-US';
        let currency = window.membershipCurrencyCode || 'USD';
        if (customCurrency) currency = customCurrency;

        // Convert amount to number if it's a string
        amount = parseFloat(amount);

        let formatted = '';
        if (typeof amount === 'number' && !isNaN(amount)) {
            let now = new Date();
            // Date logic
            let date2026 = new Date('2026-01-01');
            let date2027 = new Date('2027-01-01');

            if (culture === 'bg-BG') {
                if (now < date2026) {
                    // Until 01.01.2026: show BGN (EUR)
                    let euro = parseFloat(amount / 1.95583).toFixed(2);
                    let bgn = new Intl.NumberFormat('bg-BG', {
                        style: 'currency',
                        currency: 'BGN',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).format(amount);
                    let euroFormatted = new Intl.NumberFormat('bg-BG', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).format(euro);

                    formatted = symbol === 'no-span'
                        ? `${bgn}`
                        : `${bgn} <span style="font-size:0.9em;opacity:0.7;">(${euroFormatted})</span>`;
                } else if (now >= date2026 && now < date2027) {
                    // From 01.01.2026 to 01.01.2027: show EUR (BGN)
                    let bgn = parseFloat(amount * 1.95583).toFixed(2);
                    let bgnFormatted = new Intl.NumberFormat('bg-BG', {
                        style: 'currency',
                        currency: 'BGN',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).format(bgn);
                    let euro = new Intl.NumberFormat('bg-BG', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).format(amount);

                    formatted = symbol === 'no-span'
                        ? `${euro}`
                        : `${euro} <span style="font-size:0.9em;opacity:0.7;">(${bgnFormatted})</span>`;
                } else {
                    // After 01.01.2027: show only EUR
                    let euro = new Intl.NumberFormat('bg-BG', {
                        style: 'currency',
                        currency: 'EUR',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).format(amount);

                    formatted = `${euro}`;
                }
            } else {
                formatted = new Intl.NumberFormat(culture, {
                    style: 'currency',
                    currency: currency,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(amount);
            }
        }

        return $sce.trustAsHtml(formatted);
    }
}]);